module.exports = __webpack_public_path__ + "8a5356e9/img/delete-icon.eb7de062.svg";